import uniq from "lodash-es/uniq";
import map from "lodash-es/map";
import { IEmotionCharacterCount } from "motw_core/DTOs/emotioncharactercount";
import { Dictionary } from "motw_core/Utils/Dictionary";
import { IMappedData } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/StateProgressChart/IMappedData";
import { groupBy, sortBy } from "lodash-es";
import { FillMissingDates } from "../FillMissingDates";
import { GetMovingAverage } from "../GetMovingAverage";
import { IsToday } from "motw_core/Services/TimeServices";

export function GetCountsDictionary(
    emotionCharacterCounts: IEmotionCharacterCount[]
) {
    var emotionCharacters = uniq(
        map(emotionCharacterCounts, (ecc) => ecc.result_value)
    );

    var dictionaryMap = Object.fromEntries(
        emotionCharacters.map((emotionCharacter) => [
            emotionCharacter,
            GetMappedData(emotionCharacterCounts, emotionCharacter),
        ])
    ) as Record<string, IMappedData[]>;

    var dataDictionary: Dictionary<string, IMappedData[]> = new Dictionary(
        dictionaryMap
    );

    return dataDictionary;
}

function GetMappedData(
    emotionCharacterCounts: IEmotionCharacterCount[],
    emotionCharacter: string
): IMappedData[] {
    // Step 1: Filter the data based on result_value
    const filtered = emotionCharacterCounts.filter(
        (eccRecord) => eccRecord.result_value === emotionCharacter
    );

    // Step 2: Group by date (using only date part)
    const groupedByDate = groupBy(
        filtered,
        (ecc) =>
            new Date((ecc as IEmotionCharacterCount).result_lastmodifieddate)
                .toISOString()
                .split("T")[0]
    );

    // Step 3: Map grouped data to IMappedData format
    const mapped = map(groupedByDate, (group, date) => {
        const totalValue = group.reduce(
            (sum, item) => sum + item.result_count,
            0
        );

        return {
            time: date,
            value: totalValue,
        } as IMappedData;
    });

    // Step 4: Sort by time
    const sorted = sortBy(mapped, (mapping) => mapping.time);

    // Step 5: Fill in missing dates
    const filledInData = FillMissingDates(sorted, 0);

    // Step 6: Remove duplicate dates
    const uniqueDateMappedData = Array.from(
        new Map(filledInData.map((item) => [item.time, item])).values()
    );

    // Step 7: Remove today's data
    const withoutTodaysData = uniqueDateMappedData.filter(
        (record) => !IsToday(record.time)
    );
    
    var movingAverage = GetMovingAverage(withoutTodaysData, 7);

    return movingAverage;
}
